import { brandColors, brandGradients, statusColors, statusSoftColors, surfaceColors } from '../tokens/colors';

/**
 * Resolved semantic palette for light mode — a flat, framework-agnostic object. Web's
 * `theme/createAppTheme.ts` maps this onto MUI's `Palette`; a future RN Paper theme maps it onto
 * `MD3Colors`. Neither this file nor `createTheme.ts` imports React or any UI framework.
 */
export const lightTheme = {
  mode: 'light' as const,
  primary: brandColors.primary,
  secondary: brandColors.secondary,
  accent: brandColors.accent,
  status: statusColors,
  statusSoft: statusSoftColors.light,
  gradients: brandGradients,
  surface: surfaceColors.light,
};
